import React from 'react';
import { Route, Routes } from 'react-router-dom';
import WebhookDetail from './WebhookDetail';
import WebhookList from './WebhookList';

const WebhookRouter = () => {
  return (
    <Routes>
      <Route path={'/'} element={<WebhookList />} />
      <Route path={'/:webhookId'} element={<WebhookDetail />} />
    </Routes>
  );
};

export default WebhookRouter;
